@if (assetsResource.isLoading()) {
  <div class="text-muted small px-2 py-1">{{ 'aiReport.lbl_assets_loading' | translate }}</div>
} @else if (assetsResource.error()) {
  <div id="ai-assets-error" class="text-danger small px-2 py-1 d-flex align-items-center gap-2">
    <span>{{ 'aiReport.lbl_assets_load_failed' | translate }}</span>
    <button type="button" id="ai-assets-retry" class="btn btn-outline-secondary btn-sm" (click)="assetsResource.reload()">
      <i class="fa fa-refresh"></i> {{ 'aiReport.lbl_retry' | translate }}
    </button>
  </div>
} @else if (assetsResource.hasValue()) {
  <div class="asset-list">
    @for (asset of assetsResource.value()!; track asset.id) {
      <div class="asset-row border rounded mb-2">
        <div class="asset-row__header d-flex align-items-center justify-content-between px-3 py-2 cursor-pointer"
             (click)="toggleAsset(asset.id)">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-file-earmark"></i>
            <span class="fw-semibold">{{ asset.displayName }}</span>
            <span class="asset-type-tag">{{ assetTypeLabels().get(asset.id) }}</span>
          </div>
          <i class="bi"
             [class.bi-chevron-up]="expandedAssets().has(asset.id)"
             [class.bi-chevron-down]="!expandedAssets().has(asset.id)"></i>
        </div>

        @if (expandedAssets().has(asset.id)) {
          <div class="asset-row__body px-3 pb-3 border-top">
            <div class="pt-2 mb-2">
              <app-asset [asset]="asset" mode="view"/>
            </div>

            <div class="asset-meta border-top pt-1">
              <div class="asset-meta__toggle d-flex align-items-center justify-content-between py-1 cursor-pointer"
                   (click)="toggleMeta(asset.id); $event.stopPropagation()">
                <span class="small text-muted fw-semibold">Metadata</span>
                <i class="bi"
                   [class.bi-chevron-up]="expandedMeta().has(asset.id)"
                   [class.bi-chevron-down]="!expandedMeta().has(asset.id)"></i>
              </div>

              @if (expandedMeta().has(asset.id)) {
                <dl class="asset-meta__content small mb-0 mt-1">
                  <div class="mb-1">
                    <dt class="d-inline text-muted">ID:&nbsp;</dt>
                    <dd class="d-inline text-break">{{ asset.id }}</dd>
                  </div>
                  @if (asset.mimeType) {
                    <div class="mb-1">
                      <dt class="d-inline text-muted">MIME:&nbsp;</dt>
                      <dd class="d-inline">{{ asset.mimeType }}</dd>
                    </div>
                  }
                  @if (asset.description) {
                    <div class="mb-1">
                      <dt class="d-inline text-muted">Description:&nbsp;</dt>
                      <dd class="d-inline">{{ asset.description }}</dd>
                    </div>
                  }
                  <div class="mb-1">
                    <dt class="d-inline text-muted">Created:&nbsp;</dt>
                    <dd class="d-inline">{{ asset.createdAt | date:'short' }}</dd>
                  </div>
                  <div class="mb-1">
                    <dt class="d-inline text-muted">Modified:&nbsp;</dt>
                    <dd class="d-inline">{{ asset.modifiedAt | date:'short' }}</dd>
                  </div>
                </dl>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
